/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import PropTypes from "prop-types";

// components
import { AppContext } from "components";
import { BaseComponent } from "shared/components";
import ProductCard from "shared/components/product-card/product-card";

// controllers
import { ProductController } from "controllers";

class AddBarcodesComponent extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            barcode: "",
            products: [],
            imageURLs: [],
            loading: false
        };
        this.renderCards = this.renderCards.bind(this);
        this.resetState = this.resetState.bind(this);
    }

    getProducts() {
        return this.state.products;
    }
    reloadRef() {
        this.setState({ products: [] });
    }

    setBarcode(event) {
        const barcode = event.target.value;
        this.setState({ barcode });
    }

    alreadySelected() {
        const { products, barcode } = this.state;
        if (products.length === 0) { return false };

        return Boolean(products.find(product => product.barcode === barcode));
    }
    searchInputKeyPressed = async e => {
        const { barcode } = this.state;
        if (e.charCode === 13) {
            // enter pressed

            this.context.showLoading();
            await this.addToProducts(barcode);
            this.context.hideLoading();
            this.setState({ loading: false });

        } else {
            await this.setState({ barcode: e.target.value });
        }
    };

    addToProducts = async () => {
        const { products, barcode } = this.state;

        if (this.alreadySelected()) {
            this.showErrorToast("This barcode is already selected. Please choose another one.");
            await this.setState({ barcode: "" });
            return;
        }

        const product = await ProductController.getBarcodeOnly(barcode);
        if (typeof (product) === "string") {
            this.showErrorToast(product);
            await this.setState({ barcode: "" });
            return;
        }
        products.push(product);
        this.setState({ products });
        this.resetState({ barcode });
    }
    renderCards(products) {
        if (products.length === 0) {
            return null;
        }

        return (
            <div className="columns is-mobile is-multiline">
                {products.map(product => (
                    <div className="column is-one-quarter">
                        <ProductCard key={product.barcode} product={product} removeProduct={this.delete} />
                    </div>
                ))}
            </div >
        )
    }

    resetState() {
        this.setState({ barcode: "" });
    }

    delete(barcode) {
        const { products } = this.state;
        const newProducts = products.filter(p => p.barcode !== barcode);
        this.setState({ products: newProducts });
    }

    render() {
        const { barcode, products } = this.state;

        return (
            <div className="container">
                <div className="field has-addons">
                    <div className="control">
                        <input className="input"
                            placeholder="Type a barcode"
                            onChange={(event) => this.setBarcode(event)}
                            onKeyPress={this.searchInputKeyPressed}
                            value={barcode}
                            id="barcode"
                        />
                    </div>
                    <div className="control">
                        <a className="button is-info"
                            onClick={() => { this.addToProducts() }}>
                            Add
                        </a>
                    </div>
                </div>
                {this.renderCards(products)}
            </div>
        )
    }
}

AddBarcodesComponent.contextType = AppContext;

AddBarcodesComponent.propTypes = {
    product: PropTypes.object
};

export default AddBarcodesComponent;
